import {
    IonContent, IonTitle, IonPage, IonToolbar, IonHeader,
    IonGrid, IonButtons, IonBackButton, IonButton,
    IonIcon,
    IonSpinner
} from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { Player } from '@lottiefiles/react-lottie-player';
import successPayment from "../../../assets/animations/successGreenTick.json";
import "./PaymentCompleted.css";
import { auth } from '../../../firebaseConfig';

type Props = {
    history: any,
};

type State = {
    isProcessingPayment: boolean,
    isPaymentSucceded: boolean,
};

class PaymentSucceded extends React.Component<Props, State> {

    constructor(props: any) {
        super(props);
        this.state = {
            isProcessingPayment: false,
            isPaymentSucceded: false,
        }
    }

    componentDidMount(): void {
        auth.onAuthStateChanged(userData => {
            if (userData) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                this.setState({ isPaymentSucceded: true, isProcessingPayment: false })

            }
        })
    }

    render() {
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonBackButton defaultHref="/sessions" />
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>

                <IonContent className='paymentCompletedContent' fullscreen>
                    <IonGrid className="paymentCompletedMainGrid">
                        {
                            this.state.isProcessingPayment &&
                            <div className='paymentProcessingMainDiv'>
                                <p>Per favore, attendi qualche secondo</p>
                                <p>Stiamo processando il pagamento</p>
                                <IonSpinner style={{ width: "100px", height: "100px" }} name='bubbles'></IonSpinner>
                            </div>
                        }

                        {
                            this.state.isPaymentSucceded &&
                            <div className='paymentCompletedMainDiv'>
                                <div className="paymentCompletedSuccessDiv">
                                    <Player
                                        autoplay
                                        keepLastFrame
                                        src={successPayment}
                                    />
                                </div>
                                <div className='paymentCompletedHeaderDiv'>
                                    <p>Pagamento completato</p>
                                    <p>Grazie per aver scelto Reasy!</p>


                                </div>
                                <div className='paymentCompletedButtonsDiv'>
                                    <a
                                        className='paymentCompletedInvoiceText'
                                        onClick={() => {
                                            window.open('https://forms.gle/ysbDDin5DXPPYRwD9', '_blank')
                                        }}
                                    >
                                        Hai bisogno della fattura? 📄
                                    </a>
                                    <IonButton
                                        className='paymentCompletedCTAButton'
                                        onClick={() => {
                                            this.props.history.push('/sessions')
                                        }}
                                    >
                                        Inizia a studiare con Reasy!
                                    </IonButton>

                                </div>
                            </div>


                        }
                        {/* {!this.state.isPaymentSucceded && !this.state.isProcessingPayment &&
                            <div className='paymentCompletedErrorDiv'>
                                <p>
                                    Errore durante l'assegnazione della licenza
                                </p>
                                <IonButton onClick={() => {
                                    this.props.history.push('/support')
                                }}>Contatta il supporto</IonButton>
                            </div>} */}

                    </IonGrid>
                </IonContent>
            </IonPage>

        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        isPaymentSuccessful: state.purchases.paymentSuccess,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSucceded);